import { render, staticRenderFns } from "./placeholderScreen.vue?vue&type=template&id=d3190a9e&scoped=true&"
import script from "./placeholderScreen.vue?vue&type=script&lang=js&"
export * from "./placeholderScreen.vue?vue&type=script&lang=js&"
import style0 from "./placeholderScreen.vue?vue&type=style&index=0&id=d3190a9e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3190a9e",
  null
  
)

export default component.exports